export default __webpack_public_path__ + "static/media/frame-4.61948cd0.png";